export class MapOrnamentComponentBuilderError extends Error {}